import { render, staticRenderFns } from "./SegmentacoesTabs.vue?vue&type=template&id=607d9943&scoped=true&"
import script from "./SegmentacoesTabs.vue?vue&type=script&lang=js&"
export * from "./SegmentacoesTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607d9943",
  null
  
)

export default component.exports